module.exports = __webpack_public_path__ + "static/media/CS180.243a3aec.PNG";